import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { hasRole } from "@/lib/roles";
import { Loader2 } from "lucide-react";

export function ProtectedRoute({ children, adminOnly = false, hiddenForRoles = [] }) {
  const { state } = useAuth();
  const loc = useLocation();

  if (state === null) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#211D19] text-slate-300">
        <Loader2 className="mr-2 h-5 w-5 animate-spin" /> Chargement…
      </div>
    );
  }
  if (state === false) {
    return <Navigate to="/login" replace state={{ from: loc.pathname }} />;
  }
  if (adminOnly && !hasRole(state.user, ["admin"])) {
    return <Navigate to="/dashboard" replace />;
  }
  // Phase B rôle gestionnaire_chantier (2026-09-10) — Redirect pour rôles
  // explicitement interdits sur cette route (ex. `/pipeline` pour un
  // gestionnaire_chantier).
  if (hiddenForRoles.length > 0 && state.user && hiddenForRoles.includes(state.user.role)) {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
}
